import * as AuditActions from 'audit/AuditActions';
import {EXPORT_AUDIT_LOG_DISPLAY_STRING, EXPORT_AUDIT_LOG_UNSAVED_TABLE_TOOLTIP} from 'audit/AuditConstants';

import makeSimpleActionFunction from './makeSimpleActionFunction';

/**
 * An ActionFunction that exports audit logs for the entities inside the table.
 */
export const exportAuditLogsActionFunction = makeSimpleActionFunction({
  label: EXPORT_AUDIT_LOG_DISPLAY_STRING,
  icon: 'audit-trail',
  iconAltText: EXPORT_AUDIT_LOG_DISPLAY_STRING,
  // A freshly inserted table has no apiId yet so disable the action until the table has been persisted.
  getDisabled: ({structuredTable}) => !structuredTable.apiId,
  getTooltip: ({structuredTable}) => (structuredTable.apiId ? null : EXPORT_AUDIT_LOG_UNSAVED_TABLE_TOOLTIP),
  onInvoke: ({structuredTable}) => {
    if (!structuredTable.apiId) {
      return;
    }
    AuditActions.exportAuditLogs([structuredTable.apiId]);
  },
});
